import { createApp } from "vue"
import { register } from "swiper/element/bundle"
register()
import { MotionPlugin } from "@vueuse/motion"
import VueGtag from "vue-gtag"

import App from "./App.vue"
import { useKirby } from "./composables/use-kirby"

import "./main.css"
// self invoke async initialization
import { useRouter } from "./router"
import { store, key } from "./store"
;(async () => {
  const { getSite } = useKirby()

  const site = await getSite().catch(() => {
    document.body.innerHTML =
      "Failed to fetch Kirby site, make sure server is running"
    throw new Error("Failed to fetch Kirby site")
  })

  const router = useRouter(site)
  const app = createApp(App)

  // globals
  app.use(
    VueGtag,
    {
      config: { id: "G-4TPNTEEBLW" },
    },
    router,
  )

  app.config.globalProperties.$site = site
  app.use(router).use(store, key).use(MotionPlugin).mount("#app")
})()
